import * as yup from "yup";

export const NewsSetupValidationSchema = yup.object().shape({});
